"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BARE_JOURNEY = void 0;
exports.BARE_JOURNEY = {
    tag: '',
    name: '',
    description: '',
    internalDescription: '',
    videos: [],
    docId: '',
    criteria: [],
    published: false
};
//# sourceMappingURL=journeyModel.js.map